<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <label
      v-if="label"
      :for="$attrs.name"
    >
      {{ label }}
    </label>
    <select
      v-bind="$attrs"
      :class="inputError ? `a-input-primary a-input-danger ${inputClass}` : `a-input-primary ${inputClass}`"
      v-on="listeners"
      :ref="reference"
      @change="updateValue"
    >
      <option
        selected
        value=""
      >
      </option>
      <option
        v-for="element in elements"
        :key="element[keyField]"
        :value="element[keyField]"
        :selected="element[keyField] === value ? true : false"
      >
        {{ element[textField] }}
      </option>
    </select>
    <small
      v-if="inputError"
      class="text-color-danger"
    >
      {{ messageError }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomSelectPrimary',
  inheritAttrs: false,

  props: {
    elements: Array,
    inputError: Boolean,
    keyField: String,
    label: String,
    messageError: String,
    inputClass: String,
    reference: String,
    textField: String,
    value: [String, Number],
    wrapperClass: String
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: this.updateValue
      }
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
